( function ( $ ) {
	$( function () {
		const InviteCodeField = document.getElementById( 'invite_code' );
		const AuthorProfileContainer = document.querySelectorAll(
			'.tdb-author-box.xxx a' );
		// Modify author box link with profile link instead of author link
		AuthorProfileContainer.forEach( container => {
			container.href = cfOpts.authorLink;
		} );

		//Add profile link on author archive pages
		const AuthorArchiveContainer = document.querySelectorAll(
			'.tdb-author-box.author-archive-box' );
		AuthorArchiveContainer.forEach( container => {
			let profileLinkContainer = document.createElement('div');
			profileLinkContainer.classList.add('profile-link-container');
			let linkContainer = document.createElement( 'p' );
			linkContainer.classList.add('author-profile-link');
			let link = document.createElement( 'a' );
			link.href = cfOpts.authorLink;
			let author = cfOpts.author + "'s";
			link.textContent = 'View Profile';
			linkContainer.appendChild(link);
			profileLinkContainer.appendChild(linkContainer);
			container.prepend(profileLinkContainer);
		} );

		let InviteCode = getParameterByName( 'invite-code' );

		// This assigns admin's invite code if the query var is not present
		// this allows people to join from the Membership Requirements page without
		// an initial invite - If approved we need to assign an invite code. this
		// also assumes nobody will access this page directly. code is provided via
		// button on requirements page if ( ! InviteCode ) { InviteCode =
		// '000e831FC224B1' }

		if ( InviteCode && InviteCodeField ) {
			InviteCodeField.value = InviteCode;
		}

		function getParameterByName( name, url = window.location.href ) {
			name = name.replace( /[\[\]]/g, '\\$&' );
			var regex   = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' ),
			    results = regex.exec( url );
			if ( ! results ) {
				return null;
			}
			if ( ! results[ 2 ] ) {
				return '';
			}
			return decodeURIComponent( results[ 2 ].replace( /\+/g, ' ' ) );
		}

	} );
} )( jQuery );


